import { render, staticRenderFns } from "./StyleDialog.vue?vue&type=template&id=0d4a5fca&scoped=true"
import script from "./StyleDialog.vue?vue&type=script&lang=js"
export * from "./StyleDialog.vue?vue&type=script&lang=js"
import style0 from "./StyleDialog.vue?vue&type=style&index=0&id=0d4a5fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a5fca",
  null
  
)

export default component.exports